<template>
  <v-autocomplete
    class="font-size-14 white"
    clearable
    dense
    hide-details
    open-on-clear
    outlined
    prepend-inner-icon="mdi-factory"
    :items="organizationItems"
    :label="$t('common.organization_one')"
    :value="organizationId"
    @change="$emit('change', $event)"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'OrganizationSelector',

  props: {
    selectedOrganizationId: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      organizationItems: [],
    }
  },

  async mounted() {
    this.organizationItems = await this.getOrganizations()
  },

  computed: {
    ...mapGetters(['account']),

    organizationId() {
      return this.selectedOrganizationId || this.account.organization._id
    },
  },

  methods: {
    ...mapActions({
      getAllOrganizations: 'report/getAllOrganizations',
    }),
    async getOrganizations() {
      const response = await this.getAllOrganizations({
        disablePagination: true,
      })

      return _.chain(response.results)
        .map(organization => ({
          value: organization._id,
          text: organization.name,
        }))
        .sortBy('text')
        .value()
    },
  },
}
</script>
